import React from 'react';
import { motion } from 'framer-motion';
import { EnvelopeSimple } from '@phosphor-icons/react';

type Props = {
  onNavigate: () => void;
  bodyText: string;
  resendEmailVerification?: () => void;
};

const CheckEmail = ({ onNavigate, bodyText, resendEmailVerification }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="check-email"
    >
      <div className="check-email__icon">
        <EnvelopeSimple size={24} color="#fff" weight="bold" />
      </div>

      <h2 className="check-email__title">
        Check your <strong>email</strong>
      </h2>

      <p className="check-email__body">{bodyText}</p>

      <button onClick={onNavigate} className="auth-btn-secondary">
        Return to Login
      </button>

      {resendEmailVerification && (
        <button
          onClick={resendEmailVerification}
          className="auth-btn-link auth-btn-link--md auth-btn-link--grey"
        >
          Resend verification email
        </button>
      )}
    </motion.div>
  );
};

export default CheckEmail;
